import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import { setInvoiceDetails } from 'actions/invoiceDetailsAction';
import FSBModal from 'components/common/FSBModal';
import CustomTabs from 'components/CustomTabs';
import Heading from 'components/Heading';
import AllInvoice from './components/AllInvoice';
import Pending from './components/Pending';
import PartiallyPaid from './components/PartiallyPaid';
import FullyPaid from './components/FullyPaid';
import AddPayment from './components/AddPayment';
import { INVOICE_HEADING } from './constants';

const Invoices = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(INVOICE_HEADING.ALL);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showAddRecord, setAddRecord] = useState(false);

  const toggleAddRecord = () => {
    setAddRecord(!showAddRecord);
  };

  const drawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleViewDetail = (row) => {
    dispatch(
      setInvoiceDetails({
        status: true,
        selectedInvoice: row,
      }),
    );
  };
  return (
    <div className="staff-page">
      <div className="mb-3 top-head">
        <Heading title="Invoices" />
      </div>

      <FSBModal
        title="Add Payment"
        open={isDrawerOpen}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        message=""
        modalClass="right-drawer"
      >
        <AddPayment toggleAddRecord={toggleAddRecord} />
      </FSBModal>
      {/* <FSBModal
        title="Payment Details"
        open={invoicesDetailDrawerOpen}
        toggleAlert={invoicesDetailToggle}
        onClose={invoicesDetailToggle}
        message=""
        modalClass="right-drawer"
      >
        <PaymentDetails invoicesDetail={invoicesDetail} />
      </FSBModal> */}

      {/* <FSBModal
        title="Add Category"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showAddRecord}
        onConfirmClick={toggleAddRecord}
        onClose={toggleAddRecord}
        modalClass="right-drawer"
      >
        <AddPayment toggleAddRecord={toggleAddRecord} />
      </FSBModal> */}
      {/* <Card className="border-0 card-box">
        <CardBody>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="fw-semibold f-14 ">Pending</h4>
            <Button
              color="primary"
              size="sm"
              className="mb-2"
              onClick={toggleAddRecord}
            >
              Add Payment <RiAddFill size={20} />
            </Button>
          </div>
        </CardBody>
      </Card> */}

      <Card className="card-box border-0 page-card-box">
        <CardBody>
          {/* <div className="d-flex align-items-center border-bottom mb-3 pb-2 justify-content-between"> */}
          <CustomTabs
            tabs={[
              INVOICE_HEADING.ALL,
              INVOICE_HEADING.UNPAID,
              INVOICE_HEADING.PARTIALLYPAID,
              INVOICE_HEADING.FULLYPAID,
            ]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className=""
          />
          {/* <Button
              color="primary"
              className="text-nowrap mb-1"
              size="sm"
              onClick={drawerToggle}
            >
              Add Payment <RiAddFill size={20} />
            </Button> */}
          {/* </div> */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId={INVOICE_HEADING.ALL}>
              {activeTab === INVOICE_HEADING.ALL && (
                <AllInvoice handleViewDetail={handleViewDetail} />
              )}
            </TabPane>
            <TabPane tabId={INVOICE_HEADING.UNPAID}>
              {activeTab === INVOICE_HEADING.UNPAID && (
                <Pending handleViewDetail={handleViewDetail} />
              )}
            </TabPane>
            <TabPane tabId={INVOICE_HEADING.PARTIALLYPAID}>
              {activeTab === INVOICE_HEADING.PARTIALLYPAID && (
                <PartiallyPaid handleViewDetail={handleViewDetail} />
              )}
            </TabPane>
            <TabPane tabId={INVOICE_HEADING.FULLYPAID}>
              {activeTab === INVOICE_HEADING.FULLYPAID && (
                <FullyPaid handleViewDetail={handleViewDetail} />
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default Invoices;
